import React from "react";

// Class error boundary — catches render/commit-phase errors in its subtree
// (including React #185 "Maximum update depth exceeded", thrown from a layout
// effect) and renders a local fallback instead of letting the whole app
// white-screen. Scope it around a single feature so a crash there degrades to a
// contained "reload this view" while the rest of the app stays alive.
//
// Reset re-mounts children with a fresh key, clearing any wedged subtree state
// (e.g. dnd-kit's mid-drag measurement loop) so the user can continue without a
// full page reload.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, resetKey: 0 };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // Best-effort surface; never rethrow (that would defeat the boundary).
    try { console.error("[ErrorBoundary]", this.props.label || "", error); } catch { /* ignore */ }
  }

  reset = () => this.setState((s) => ({ hasError: false, resetKey: s.resetKey + 1 }));

  render() {
    if (this.state.hasError) {
      if (this.props.renderFallback) return this.props.renderFallback(this.reset);
      return (
        <div style={{ maxWidth: 480, margin: "80px auto", padding: "24px", textAlign: "center", color: "#e2e8f0", fontFamily: "system-ui, sans-serif" }}>
          <div style={{ fontSize: 15, marginBottom: 14 }}>Something hit a snag here.</div>
          <button
            onClick={this.reset}
            style={{ background: "linear-gradient(135deg,#FF6B00,#E55A00)", color: "#fff", border: "none", borderRadius: 8, padding: "8px 18px", fontSize: 14, fontWeight: 700, cursor: "pointer" }}
          >
            Reload
          </button>
        </div>
      );
    }
    return <React.Fragment key={this.state.resetKey}>{this.props.children}</React.Fragment>;
  }
}
